// extracted by mini-css-extract-plugin
export default {"cell":"style_cell__42p1J","cellSelected":"style_cellSelected__9HUl6","correct":"style_correct__WHCxl","wrong":"style_wrong__CSWMl","endTestingBg":"style_endTestingBg__Uhkhq"};